<template>
  <v-app>
    <Header />
    <v-content>
      <Home />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Home
  },
  data: () => ({})
};
</script>

<style lang="scss">
@import "../scss/main.scss";
.v-content__wrap {
  padding: 20px 60px;
}
@media only screen and (min-width: 1400px) {
  .v-content__wrap {
    padding: 20px 180px;
  }
}
@media only screen and (max-width: 414px) {
  .v-content__wrap {
    padding: 0px 20px;
    padding-top: 10px;
  }
}
</style>
